<template>
  <button
    class="btn btn-primary btnDeleteColor"
    type="button"
    :disabled="disabled"
    @click="$emit('click')"
  >
    {{ buttonName }}
  </button>
</template>

<script>
export default {
  name: 'ButtonDelete',
  props: {
    buttonName: String,
    disabled: Boolean
  }
}
</script>

<style scoped lang="scss">
.btnDeleteColor {
  min-width: 80px;
  background-color: rgb(233, 29, 7) !important;
  border: none;
  height: 25px;
  font-size: 14px;
  padding: 0 1em;
}
.btnDeleteColor:hover {
  filter: opacity(70%);
}
button:disabled {
  color: rgb(154, 154, 154);
  background-color: rgb(225, 225, 225);
  border: none;
  border-radius: 4px;
}
</style>
